/** 
 * Brightcove Learning Services Module
 */
var SCM = SCM || {};
SCM.Utilities = SCM.Utilities || {};

(function (bc, $) {
    bc.init = function () {
        if ($('.brightcove-wrapper video.video-js, .brightcove-player').length !== 0) {
            var jsSrc = 'https://players.brightcove.net/1611106596001/BkMnETZOZ_default/index.min.js';
            // load JS only if video exists on page
            $.getScript(jsSrc, function () {
            });
        }
        if ($('.brightcove-wrapper-audio video.video-js').length !== 0) {
            var jsSrc = 'https://players.brightcove.net/1611106596001/ryQZHF29_default/index.min.js';
            // load JS only if video exists on page
            $.getScript(jsSrc, function () {
            });
        }
    };
})(SCM.Utilities.Brightcove = SCM.Utilities.Brightcove || {}, jQuery);
